<template>
<div>
    <b-modal v-model="isShowModal" :no-close-on-backdrop="true" id="modal-change-password" title="Change Password" hide-footer :centered="true" ref="modal-change-password">
        <div class="s-exp-desc">Your password expired. Please change new password for continue</div>
        <b-form class="form-vertical login-form formV2" autocomplete="off">
            <gofix-form-input label="Current Password" v-model="$v.user.current_password.$model" :type="type" required>
                <template slot="gofixInput:text:after-desc">
                    <p class="desc">
                        <small v-if="$v.user.current_password.$error" class="clear-small label-error">Current Password doesn’t match</small>
                    </p>
                </template>
            </gofix-form-input>
            <gofix-form-input label="New Password" v-model="$v.user.new_password.$model" :type="type" required>
                <template slot="gofixInput:text:after-desc">
                    <p class="desc">
                        <small v-if="$v.user.new_password.$error" class="clear-small label-error">New Password doesn’t match</small>
                    </p>
                </template>
            </gofix-form-input>
            <gofix-form-input label="Confirm New Password" v-model="$v.user.confirm_new_password.$model" :type="type" required>
                <template slot="gofixInput:text:after-desc">
                    <p class="desc">
                        <small v-if="$v.user.confirm_new_password.$error" class="clear-small label-error">Confirm New Password doesn’t match</small>
                    </p>
                </template>
            </gofix-form-input>
        </b-form>
        <b-button-group class="d-block text-right">
            <gofix-button label="CHANGE" @click="changePassword" :loading="isAction" noBorder></gofix-button>
        </b-button-group>
    </b-modal>
    <b-toast id="toast-custom2" variant="danger" solid>
        <template #toast-title>
            <div class="d-flex flex-grow-1 align-items-baseline">
            <strong class="mr-auto">Notification!</strong>
            </div>
        </template>
        <div class="err-pwd-toast" v-if="errorMessage">
            <div v-html="errorMessage"></div>
        </div>
    </b-toast>
    </div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { required, sameAs } from 'vuelidate/lib/validators'
    import Loader from '../pages/Loader.vue';
    export default {
        name: 'ResetPassword',
        props: {
            show: {
                type: Boolean,
                required: true,
                default: false
            }
        },
        components: {
            Loader
        },
        data () {
            return {
                user : {
                    current_password:'',
                    new_password : '',
                    confirm_new_password:'',
                    platform: null
                },
                errorMessage:null,
                platforms:[],
                isAction : false,
                type : 'password',
                isLoading: false,
                isShowModal:this.show,
                timer: null,
                timer1:null
            }
        },
        mixins: [validationMixin],
        validations: {
            user: {
                current_password : {
                    required
                },
                new_password : {
                    required
                },
                confirm_new_password : {
                    sameAsPassword: sameAs("new_password"),
                    required
                }
            }
        },
        computed: {
           
        },
        watch: {
            show: function(val){
                this.isShowModal = val
            }    
        },
        mounted(){
            //this.$refs['modal-change-password'].show();
        },
        methods:{
            convertNewLine(str){
                return str.replace(/\n/g, '<br />');
            },
            async changePassword(){
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return false;
                }
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                if (this.timer1) {
                    clearTimeout(this.timer1);
                    this.timer1 = null;
                }
                this.isAction = true;
                this.errorMessage = null
                this.timer = setTimeout(async () => {
                    this.$store.dispatch(`v2UserController/changePasswordExpired`, this.user)
                    .then(response => {
                        this.isAction = false;
                        if(response.code == '400'){
                            if(response.data){      
                                this.errorMessage = this.convertNewLine(response.message);
                                this.$bvToast.show('toast-custom2');
                                return;
                            }
                            return this.$alertNotification(response.message, "danger");
                        }else if(response.code == '200'){
                            this.$alertNotification(response.message, "success");
                            this.timer1 = setTimeout(async () => {
                                this.logout();
                            },3000)
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
                }, 300);
            },
            async logout() {
                if(goFix){
                    await goFix._logout();
                }else{
                    this.$store.dispatch('AuthController/logout')
                        .then(result => {
                            this.$store.reset();
                            this.$router.push(`/login`)
                        })
                        .catch(error => {
                            this.$router.push(`/login`)
                        })
                }
                localStorage.clear();
            },
        }
    }
</script>